<fieldset *ngIf="!error" class="ais-RefinementList catPersonnalization">
  <!-- this div is here to simulate the ng-ais-header container -->
  <div>
    <button
      class="ais-RefinementList-header ais-header"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
      [attr.aria-expanded]="showRefinementBody"
    >
      <legend i18n="@@PERSO.FILTER_SET.HEADER">Personalization</legend>
    </button>
  </div>

  <!-- Refinement body -->
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <ng-container *ngIf="hasUserPreferences; else persoNotSet">
      <ng-container *ngIf="personalizationIsApplicable; else noResult">
        <input
          id="personalizationInput"
          class="filters_checkbox_input vc-inputToggle__input visuallyhidden"
          type="checkbox"
          (change)="togglePersonalization()"
          [attr.checked]="personalizationActive"
        />
        <label
          for="personalizationInput"
          class="filters_checkbox_label vc-inputToggle__label"
          i18n="@@PERSO.FILTER_SET.TITLE"
        >
          For Me
        </label>
        <p class="catPersonnalization__info vc-text-s" i18n="@@PERSO.FILTER_SET.SUBTITLE">
          Hide the items that don’t fit your size
        </p>
        <ul class="catPersonnalization__list">
          <li *ngIf="universeTag" class="catPersonnalization__list__tag">{{ universeTag.label }}</li>
          <li
            *ngFor="let category of categoryTags"
            [ngClass]="{catPersonnalization__list__tag: category?.sizes.length}"
          >
            <ng-container *ngIf="category?.sizes.length">
              {{ category?.label }}
            </ng-container>
            <span *ngFor="let size of category?.sizes; last as isLast"
              >{{ size?.label }}<ng-container *ngIf="!isLast">, </ng-container></span
            >
          </li>
        </ul>
        <button
          class="vc-link catPersonnalization__link"
          (click)="openPersonalization()"
          i18n="@@PERSO.FILTER_SET_EDIT.CTA"
        >
          Edit your preferences
        </button>
      </ng-container>
    </ng-container>
    <ng-template #persoNotSet>
      <p class="catPersonnalization__intro">
        <vc-sprite-icons class="catPersonnalization__intro__icon" name="sparkles"></vc-sprite-icons>
        <span i18n="@@PERSO.FILTER_NOT_SET.SUBTITLE" class="vc-text-s">
          Personalize your feed by picking your universe and sizes.
        </span>
      </p>
      <button
        class="vc-btn vc-btn--medium vc-btn--outline vc-btn--full catPersonalization__"
        i18n="@@PERSO.FILTER_NOT_SET.CTA"
        (click)="openPersonalization()"
      >
        Add
      </button>
    </ng-template>
    <ng-template #noResult>
      <p class="vc-text-s catPersonnalization__noResult" i18n="@@PERSO.FILTER_SET.NORESULT">
        Personalization is not applicable to this search
      </p>
    </ng-template>
  </div>
</fieldset>
